<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Job Quotes'"
      [canGoBack]="true"
      id="top-nav-height" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  @if (loaded && !isRightSideContent && !windowService.isDesktopRes) {
    <div class="job-quotes-sticky-header">
      <tidy-wrapper>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-top: 5px;
          ">
          <div>
            <tidy-row class="vertical-align-center">
              <tidy-image
                class="body-size"
                [src]="'assets/img/icons/number_1_white.svg'" />
              <tidy-text [actionBody]="service" class="white" />
            </tidy-row>
            <tidy-row class="vertical-align-center">
              <tidy-image
                class="body-size"
                [src]="'assets/img/icons/number_2_white.svg'" />
              <tidy-text [actionBody]="dateLabel" class="white" />
            </tidy-row>
          </div>
          <div>
            @if (selectedPrice) {
              <tidy-row class="extra-left-padding">
                <tidy-text
                  [title]="selectedPrice | tcurrency"
                  class="text-price custom-text-price" />
              </tidy-row>
            }
          </div>
        </div>
        <tidy-button
          [text]="'Review Booking'"
          [action]="boundConfirmBooking"
          [disabled]="!selectedPrice"
          class="primary full-width" />
      </tidy-wrapper>
    </div>
  }
  <tidy-wrapper
    [class]="isRightSideContent ? 'right-side-extra-bottom-padding' : ''">
    <ng-container
    *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    @if (!loaded) {
      @for (i of [1, 2]; track i) {
        <tidy-card [class.quote-card-margin]="i > 1">
          <tidy-row [align]="'center'" [alignLastItemRight]="true">
            <ion-skeleton-text
              animated
              style="width: 120px; height: 20px; border-radius: 4px;" />
            <ion-skeleton-text
              animated
              style="width: 60px; height: 20px; border-radius: 4px;" />
          </tidy-row>
          <tidy-row>
            <ion-skeleton-text
              animated
              style="width: 80%; height: 16px; border-radius: 4px;" />
          </tidy-row>
          <tidy-row>
            <ion-skeleton-text
              animated
              style="width: 100px; height: 18px; border-radius: 4px;" />
          </tidy-row>
          <tidy-row>
            <ion-skeleton-text
              animated
              style="width: 70px; height: 32px; border-radius: 4px; margin-right: 8px;" />
            <ion-skeleton-text
              animated
              style="width: 70px; height: 32px; border-radius: 4px; margin-right: 8px;" />
            <ion-skeleton-text
              animated
              style="width: 70px; height: 32px; border-radius: 4px;" />
          </tidy-row>
        </tidy-card>
      }
    }

    @for (quote of quotes; track quote; let i = $index) {
      <tidy-card [class.quote-card-margin]="i > 0">
        <tidy-row [align]="'center'" [alignLastItemRight]="true">
          <div class="pro-name-row">
            @if (quote.profileImageUrl) {
              <img [src]="quote.profileImageUrl" class="pro-avatar" />
            }
            <tidy-text [title]="quote.name" />
          </div>
          <tidy-text [title]="quote.singlePrice | tcurrency" />
        </tidy-row>

        @if (quote.pro_website_url_suffix) {
          <tidy-row>
            <tidy-text
              [body]="('https://tidy.com/' | translate) + quote.pro_website_url_suffix"
              (action)="openWebsite('https://tidy.com/' + quote.pro_website_url_suffix)"
              class="link" />
          </tidy-row>
        }

        @if (quote.pitchDescription) {
          <tidy-row>
            <tidy-text
              [helper]="quote.pitchDescription" />
          </tidy-row>
        }

        @if (quote.requiredCredentials?.length) {
          <tidy-row class="credential-chips-row">
            @for (cred of quote.requiredCredentials; track cred.type) {
              <span class="credential-chip" [class.credential-missing]="!cred.satisfied">
                {{ cred.label }}
              </span>
            }
          </tidy-row>
        }

        @if (quote.displayCredentials?.length) {
          <tidy-row class="credential-chips-row">
            @for (credential of quote.displayCredentials; track credential.type) {
              <span class="credential-chip">
                {{ credential.label }}
              </span>
            }
          </tidy-row>
        }

        @if (quote.singleNotes) {
          <tidy-row>
            <tidy-text [helper]="quote.singleNotes" />
          </tidy-row>
        }

        @for (date of quote.dates; track date) {
          <tidy-row [class.date-row]="true">
            <tidy-text [header]="date.date | parseDateTime:'dddd MMM d':''" />
          </tidy-row>
          <form [formGroup]="form">
            <tidy-radio-button
              chunkSize="3"
              formControlName="time"
              (optionChange)="selectTime($event, quote, date)"
              [form]="form.controls.time"
              [(ngModel)]="form.value.time"
              [items]="date.times" />
          </form>
        }
      </tidy-card>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper
    [style.padding-top.px]="topNavHeight"
    [showCardDesign]="true"
    [templateRightColumn]="rightColumn"
    [templateContent]="content" />
}

<ng-template #reviewBooking>
  <tidy-wrapper class="custom-right-column black-column" style="min-height: auto !important;">
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      ">
      <div>
        <tidy-row class="vertical-align-center">
          <tidy-image
            class="body-size"
            [src]="'assets/img/icons/number_1_white.svg'" />
          <tidy-text [actionBody]="service" class="white" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image
            class="body-size"
            [src]="'assets/img/icons/number_2_white.svg'" />
          <tidy-text [actionBody]="dateLabel" class="white" />
        </tidy-row>
      </div>
      <div>
        @if (selectedPrice) {
          <tidy-row class="extra-left-padding">
            <tidy-text
              [title]="selectedPrice | tcurrency"
              class="text-price custom-text-price" />
          </tidy-row>
        }
      </div>
    </div>

    <tidy-button
      [text]="'Review Booking'"
      [action]="boundConfirmBooking"
      [disabled]="!selectedPrice"
      class="primary" />
  </tidy-wrapper>
</ng-template>

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="reviewBooking" />
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
